// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sso-error-container{margin-bottom:15px;margin-top:15px}.sso-error-container i{font-size:32px}.sso-error-container .sso-error-head{background-color:#fff!important;padding:12px}.sso-error-container .sso-error-head p{font-size:12px}.sso-error-container .common-reasons{padding-top:12px}.sso-error-container .next-steps{padding-bottom:10px;padding-top:3px}.sso-error-container .card-step{height:100%}.sso-error-container .param{display:inline-block;margin-right:8px}", ""]);
// Exports
module.exports = exports;
